import { useCallback } from "react";
import defaultThumb from "../../../../assets/VZY/default.png";
import play from "../../../../assets/VZY/play.svg";
import { useNavigate } from "react-router-dom";

export const SelfhelpVideos = ({ fetchHelpVideoList = [] }) => {
  const navigate = useNavigate();

  const formatCategoryForUrl = useCallback((value = "") => {
    return value
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }, []);

  const truncateText = useCallback((text = "", maxLength = 30) => {
    if (text.length <= maxLength) return text;
    return `${text.slice(0, maxLength)}…`;
  }, []);

  const handleRoute = (itemDetails) => {
    const formattedCategory = formatCategoryForUrl(itemDetails?.contentTitle);

    navigate(`/VZYSupport/video/${formattedCategory || "notFound"}`, {
      state: {
        detailsIDs: itemDetails,
      },
    });
  };

  if (!Array.isArray(fetchHelpVideoList) || fetchHelpVideoList.length === 0) {
    return <p className="no-data-text">No videos available</p>;
  }

  return (
    <>
      {fetchHelpVideoList.map((video) => {
        const fullTitle = video?.contentTitle || "Untitled Video";
        const displayTitle = truncateText(fullTitle, 30);

        return (
          <div className="col-video-4" key={video?.id ?? fullTitle}>
            <div
              className="vzy-video-card"
              role="button"
              tabIndex={0}
              onClick={() => handleRoute(video)}
              onKeyDown={(e) => e.key === "Enter" && handleRoute(video)}
            >
              <div className="video-thumbnail">
                <img
                  src={video?.thumbnailUrl || defaultThumb}
                  alt={fullTitle}
                  className="thumbnailUrl"
                  onError={(e) => {
                    e.currentTarget.src = defaultThumb;
                  }}
                />

                <div className="play-overlay">
                  <img src={play} alt="Play video" />
                </div>
              </div>

              <h6 className="video-title" title={fullTitle}>
                {displayTitle}
              </h6>
            </div>
          </div>
        );
      })}
    </>
  );
};
